/*  Unique Uid  */
export const uid = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

export const pocNameRegex = '^[a-zA-Z0-9_-]+$';
